import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import { HELP_MODES } from '../../../utils/constant';
import TableActionButtonAtom from '../../../components/atoms/table-action-button/table-action-button';

const getOrganisationTableColumns = (t, onOrganisationEdit, onOrganisationDelete, helpMode = HELP_MODES.BASIC) => {
    return [
        {
            field: 'provided',
            headerName: t('provided'),
            unSortIcon: true,
        },{
            field: 'name',
            headerName: t('name'),
            unSortIcon: true,
        },
        {
            headerName: t('action'),
            sortable: false,
            maxWidth: 120,
            cellRenderer: (props) => {
                const {data, rowIndex} = props;
                return <div className="d-flex ag-action-cell" title={t('edit')}> 
                    <TableActionButtonAtom
                        t={t}
                        helpMode={helpMode}
                        icon={faEdit}
                        onClickAction={() => onOrganisationEdit(data, rowIndex)}
                        tooltipTitle='action-edit'
                    />
                    <TableActionButtonAtom
                        t={t}
                        helpMode={helpMode}
                        icon={faTrash}
                        className="mx-2"
                        onClickAction={() => onOrganisationDelete(data, rowIndex)}
                        tooltipTitle='action-delete'
                    />
                </div>
            }
        }
    ];
}

export {
    getOrganisationTableColumns
}